import { RESET_VALUES } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_VALUES]();
